<template>
  <div class="answer">
    <div class="title">
      <img src="@/assets/img/weekReport/answer.png" alt="" />
      <h3>答题量分析</h3>
    </div>
    <div class="analysis">
      <ul>
        <li>
          本周做题<span>{{ answerTitinfo.questionCount }}</span
          >道, 打败了<span>{{ answerTitinfo.defeatRate || 0 }}%</span>的学员，再接再厉,
          <p v-if="answerTitinfo.week">
            其中,{{ answerTitinfo.week }}答题量为本周最高，答题<span>{{ answerTitinfo.value }}</span
            >道
          </p>
        </li>
      </ul>
    </div>
    <div class="line">
      <div id="columnchartPerHaibao"></div>
    </div>
    <div class="list">
      <ul>
        <li>
          <div>英语</div>
          <p>{{ answerTitinfo.englishQuestionNum || 0 }}<span>道</span></p>
        </li>
        <li>
          <div>数学</div>
          <p>{{ answerTitinfo.mathQuestionNum || 0 }}<span>道</span></p>
        </li>
        <li v-if="answerTitinfo.questionCount - answerTitinfo.lastQuestionNum > 0">
          <div>
            对比上周
            <img src="@/assets/img/weekReport/compare_up.png" alt="" />
          </div>
          <p>+{{ answerTitinfo.questionCount - answerTitinfo.lastQuestionNum }}<span>道</span></p>
        </li>
        <li v-else>
          <div>
            对比上周
            <img
              v-if="answerTitinfo.questionCount - answerTitinfo.lastQuestionNum != 0"
              src="@/assets/img/weekReport/compare_down.png"
              alt=""
            />
          </div>
          <p>{{ answerTitinfo.questionCount - answerTitinfo.lastQuestionNum }}<span>道</span></p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { Line } from '@antv/g2plot';
export default {
  props: {
    answerTitinfo: {
      type: Object,
      default: () => {},
    },
    answerData: {
      type: Array,
      default: () => [],
    },
    chooseList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      baseInfo: false,
    };
  },
  watch: {},
  mounted() {
    if (this.chooseList[0]?.select) {
      this.baseInfo = true;
    }
    this.initData();
  },
  methods: {
    initData() {
      const data = this.answerData;
      const columnchartPerHaibao = new Line('columnchartPerHaibao', {
        data,
        height: 240,
        xField: 'week',
        yField: 'value',
        seriesField: 'name',
        smooth: true,
        color: ['#4A77FF', '#FF7F41'],
        appendPadding: [0, 0, 20, 0],
        point: {
          visible: true,
        },
        legend: {
          position: 'bottom',
          marker: {
            symbol: 'circle',
            style: (oldStyle) => {
              return {
                ...oldStyle,
                fill: oldStyle.stroke,
                r: 6,
                // 去除描边
                lineWidth: 0,
              };
            },
          },
        },
        xAxis: {
          label: {
            visible: true,
            style: {
              fill: '#999',
              fontSize: 12
            },
          },
        },
        yAxis: {
          label: {
            visible: true,
            style: {
              fill: '#999',
            },
          },
        },
      });

      columnchartPerHaibao.render();
    },
  },
};
</script>

<style scoped lang="scss">
.answer {
  position: relative;
  width: 678px;
  background: #ffffff;
  box-shadow: 0px 4 11px 0px rgba(0, 0, 0, 0.02);
  border-radius: 14px;
  margin: 0 auto 20px;
  padding: 30px;
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    img {
      display: block;
      width: 30px;
      height: 30px;
      margin-right: 7px;
    }
    h3 {
      font-size: 29px;
      font-weight: 500;
      color: #333333;
    }
  }
  .analysis {
    margin-bottom: 36px;
    ul {
      li {
        position: relative;
        font-size: 25px;
        font-weight: 400;
        color: #333333;
        margin-bottom: 20px;
        padding-left: 26px;
        line-height: 40px;
        span {
          color: #ff3938;
        }
      }
    }
  }
  .line {
    height: 300px;
  }
  .list {
    width: 612px;
    background: #f9f9f9;
    border-radius: 14px;
    margin: 160px auto 0;
    padding: 30px 0px 30px 0px;
    ul {
      display: flex;
      align-items: center;
      justify-content: space-between;
      li {
        position: relative;
        width:33.3%;
        text-align: center;
        div {
          font-size: 25px;
          font-weight: 400;
          color: #999999;
          text-align: center;
          margin-bottom: 30px;
          img {
            display: inline-block;
            width: 30px;
            height: 30px;
            vertical-align: middle;
          }
        }
        p {
          font-size: 36px;
          font-weight: 500;
          color: #ff7f41;
          span {
            font-size: 22px;
            color: #333333;
            margin-left: 6px;
          }
        }
      }
      li:after {
        position: absolute;
        right: 0px;
        top: 30px;
        display: block;
        content: '';
        width: 2px;
        height: 30px;
        background: #453c3c3d;
      }
      li:last-child:after {
        display: none;
      }
    }
  }
}
</style>
